import { Routes, Route } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import MainLayout from './components/layout/MainLayout'
import Login from './modules/auth/Login'
import CommandCenter from './modules/command-center/CommandCenter'
import AssetIntelligence from './modules/asset-intelligence/AssetIntelligence'
import PredictiveOps from './modules/predictive-ops/PredictiveOps'
import ComparativeAnalytics from './modules/comparative-analytics/ComparativeAnalytics'
import RootCauseExplorer from './modules/root-cause/RootCauseExplorer'
import MaintenanceIntelligence from './modules/maintenance/MaintenanceIntelligence'
import SelfLearning from './modules/self-learning/SelfLearning'
import ExecutiveInsights from './modules/executive/ExecutiveInsights'
import Settings from './modules/settings/Settings'

function App() {
  const { isAuthenticated } = useAuth()

  // Show login if not authenticated
  if (!isAuthenticated) {
    return <Login />
  }

  return (
    <MainLayout>
      <Routes>
        <Route path="/" element={<CommandCenter />} />
        <Route path="/assets" element={<AssetIntelligence />} />
        <Route path="/assets/:assetId" element={<AssetIntelligence />} />
        <Route path="/predictions" element={<PredictiveOps />} />
        <Route path="/compare" element={<ComparativeAnalytics />} />
        <Route path="/root-cause" element={<RootCauseExplorer />} />
        <Route path="/root-cause/:assetId" element={<RootCauseExplorer />} />
        <Route path="/maintenance" element={<MaintenanceIntelligence />} />
        <Route path="/learning" element={<SelfLearning />} />
        <Route path="/executive" element={<ExecutiveInsights />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
    </MainLayout>
  )
}

export default App
